export const iconFontAwesomeDisasterCrisisPersonRifle = (
	<i className="fa-solid fa-person-rifle"></i>
);
